<template src="./template.html"></template>
<style src="./styles.scss" scoped lang="scss"></style>

<script>
  import { mapActions, mapState } from 'vuex'
  import AppBar from './AppBar'
  import LegalFooter from '@/components/layout/LegalFooter'

  export default {
    name: 'LandingPage',
    metaInfo() {
      return {
        title: this.$t('meta.page.title', { name: this.page ? this.page.title : '' }),
      }
    },
    components: {
      AppBar,
      ComponentLoader: () => import('@/components/modules/ComponentLoader'),
      LegalFooter,
    },
    data() {
      return {
        moduleWithoutExtraContainer: [
          'hero_register',
          'landing_page_teaser',
        ],
      }
    },
    computed: {
      ...mapState('pages', [ 'page' ]),
      ...mapState('auth', { activeUser: 'status' }),
      ...mapState('auth', ['settings']),
    },
    mounted() {
      this.requestPageOrRedirect()
    },
    destroyed() {
      this.clearPage()
    },
    methods: {
      ...mapActions('pages', [
        'clearPage',
        'getPage',
      ]),
      async requestPageOrRedirect() {
        if (this.settings && this.settings.pages && this.settings.pages.landing) {
          if (this.activeUser && this.$route.meta.requiresAnon) {
            this.$router.replace({ name: 'dashboard' })
          } else {
            await this.getPage(this.settings.pages.landing)
          }
        } else if (this.activeUser) {
          this.$router.replace({ name: '404' })
        } else {
          this.$router.replace({ name: 'login' })
        }
      },
    },
  }
</script>
